import { pick, get } from 'underscore';
import { useEffect, useState, useContext } from 'react';
import appConfig from '@bingads-webui-component-legacy/config/index';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
import { ObjectiveIDs } from '@bingads-webui-campaign-react/campaign-onboarding-v2';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { useWizardService } from '@bingads-webui-react/wizard';
import { BiddingSchemes } from './constants';

const getDisplayPlusCampaignObjective = () => {
  let displayPlusCampaignObjective = appConfig.get('CampaignObjective');
  if (!displayPlusCampaignObjective) {
    if (localStorage && localStorage.supportsStorage()) {
      displayPlusCampaignObjective = localStorage.get('CampaignObjective');
      displayPlusCampaignObjective = displayPlusCampaignObjective && displayPlusCampaignObjective.type;
      appConfig.set('CampaignObjective', displayPlusCampaignObjective);
    }
  }

  return displayPlusCampaignObjective;
};

const readConversionGoalDetails = (cid, aid) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)['Default.ConversionGoalDetails']
    .$makeCall()
    .toPromise();

const whitelistedSchemaPropertyKeys = [
  'IsActiveConversionGoalPresent', 'IsActiveConversionGoalPresentWithValidRevenueValue',
];

const getConversionGoalsDetails = (cid, aid) => readConversionGoalDetails(cid, aid)
  .then(model => pick(model, whitelistedSchemaPropertyKeys));

const getBiddingSchemeForConversions = (cid, aid) =>
  getConversionGoalsDetails(cid, aid).then((goalDetails) => {
    if (goalDetails.IsActiveConversionGoalPresent) {
      return BiddingSchemes.MaxConversions;
    }

    return BiddingSchemes.EnhancedCpc;
  });

export const getBiddingScheme = (cid, aid) => {
  const objective = getDisplayPlusCampaignObjective();

  switch (objective) {
    case ObjectiveIDs.Conversions:
      return getBiddingSchemeForConversions(cid, aid);
    case ObjectiveIDs.Consideration:
      return new Promise((resolve) => {
        resolve(BiddingSchemes.EnhancedCpc);
      });
    case ObjectiveIDs.Awareness:
      return new Promise((resolve) => {
        resolve(BiddingSchemes.ManualCpm);
      });
    default:
      return new Promise((resolve) => {
        resolve(undefined);
      });
  }
};

export const useBiddingScheme = ({
  cid, aid, getDefaultCampaign, i18n,
}) => {
  const [biddingScheme, setBiddingScheme] = useState(null);
  const { state } = useWizardService();

  const serverContext = useContext(ServerContext);

  useEffect(() => {
    const biddingSchemeContext = get(state, ['context', 'wizardData', 'campaign', 'BiddingScheme', 'Type']);
    if (biddingSchemeContext) {
      setBiddingScheme(biddingSchemeContext);
      return;
    }

    getBiddingScheme(cid, aid).then((biddingSchemeRes) => {
      if (biddingSchemeRes) {
        setBiddingScheme(biddingSchemeRes);
      } else {
        setBiddingScheme(getDefaultCampaign(i18n, serverContext).data.BiddingScheme.Type);
      }
    });
  }, [cid, aid, state, getDefaultCampaign, i18n, serverContext]);

  return biddingScheme;
};

